import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Download,
  Heart,
  Film,
  Settings,
  Info,
  ChevronRight,
  LogOut,
} from "lucide-react";
import { logOut, getCurrentUser, getUserData } from "../services/authService";

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = getCurrentUser();
      if (currentUser) {
        setUser(currentUser);
        try {
          const data = await getUserData(currentUser.uid);
          setUserData(data);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        // User not logged in, redirect to sign in
        navigate("/signin");
      }
      setLoading(false);
    };

    fetchUserData();
  }, [navigate]);

  const menuItems = [
    { icon: User, label: "Account Settings", action: "settings" },
    { icon: Download, label: "Download Quality", action: "quality" },
    { icon: Heart, label: "My Watchlist", action: "list" },
    { icon: Film, label: "Viewing History", action: "history" },
    { icon: Settings, label: "App Settings", action: "app-settings" },
    { icon: Info, label: "About Sankofa", action: "about" },
  ];

  const handleSignOut = async () => {
    try {
      await logOut();
      navigate("/signin");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  if (loading) {
    return (
      <div className="profile-container">
        <div style={{ textAlign: "center", padding: "60px 20px" }}>
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect to sign in
  }

  // Get user initials for avatar
  const getInitials = () => {
    if (user.displayName) {
      return user.displayName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    }
    return user.email ? user.email[0].toUpperCase() : "U";
  };

  return (
    <div className="profile-container fade-in-up">
      <div className="profile-header">
        <div className="profile-avatar">
          {user.photoURL ? (
            <img
              src={user.photoURL}
              alt={user.displayName}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            getInitials()
          )}
        </div>
        <h2 className="profile-name">
          {user.displayName || "User"}
        </h2>
        <p className="profile-email">{user.email}</p>
      </div>

      <div className="profile-menu">
        {menuItems.map((item, idx) => (
          <button key={idx} className="menu-item">
            <div className="menu-item-left">
              <item.icon size={22} />
              {item.label}
            </div>
            <ChevronRight size={20} />
          </button>
        ))}
      </div>

      <button
        className="menu-item sign-out-btn"
        onClick={handleSignOut}
      >
        <div className="menu-item-left">
          <LogOut size={22} />
          Sign Out
        </div>
      </button>
    </div>
  );
};

export default Profile;